import {
  TrackTypeEnum,
  TrackUploadStatus,
  jingleCreate,
  jingleDelete,
  jingleUpdate,
} from '@/entities/tracks'
import {
  type TracksQueryModelWithPagination,
  createTracksQueryModel,
} from '@/entities/tracks'
import { createModalModel } from '@/shared/lib/model-factories'
import { createEvent, createStore } from 'effector'
import { sample } from 'effector'
import { createGate } from 'effector-react'

export const JinglesSelectionTableGate = createGate()

export const jinglesSelectionTableJinglesQueryModel = createTracksQueryModel({
  initialFilters: {
    Limit: 5,
    UploadStatuses: [TrackUploadStatus.Uploaded],
    Types: [TrackTypeEnum.Jingle],
  },
  usePagination: true,
  accumulate: false,
}) as TracksQueryModelWithPagination
const { availableSet, unavailableSet } = jinglesSelectionTableJinglesQueryModel
export const {
  //   Query
  query: jinglesSelectionTableQuery,
  //   Init
  filtersInit: jinglesSelectionTableFiltersInit,
  //   Search
  $search: $jinglesSelectionTableSearch,
  searchChanged: jinglesSelectionTableSearchChanged,
  searchReset: jinglesSelectionTableSearchReset,
  //   Sort
  $sort: $jinglesSelectionTableSort,
  sortChanged: jinglesSelectionTableSortChanged,
  sortReset: jinglesSelectionTableSortReset,
  //   Pagination
  $page: $jinglesSelectionTablePage,
  pageChanged: jinglesSelectionTablePageChanged,
  pageReset: jinglesSelectionTablePageReset,
  $pageSize: $jinglesSelectionTablePageSize,
  //   Refresh
  refreshed: jinglesSelectionTableRefreshed,
} = jinglesSelectionTableJinglesQueryModel

export const $jinglesSelectionTableSearchInputValue = createStore('')
  .on(jinglesSelectionTableSearchChanged, (_, q) => q)
  .reset(jinglesSelectionTableSearchReset)

sample({
  clock: JinglesSelectionTableGate.open,
  target: availableSet,
})

sample({
  clock: availableSet,
  target: jinglesSelectionTableRefreshed,
})

sample({
  clock: JinglesSelectionTableGate.close,
  target: unavailableSet,
})

sample({
  clock: [
    jingleCreate.finished.success,
    jingleUpdate.finished.success,
    jingleDelete.finished.success,
  ],
  target: jinglesSelectionTableRefreshed,
})

// Selection
export const jingleSelectionReset = createEvent()
export const jingleIdSelected = createEvent<string>()
export const $selectedJingleIds = createStore<string[]>([])
  .on(jingleIdSelected, (state, id) =>
    state.includes(id) ? state.filter((i) => i !== id) : [...state, id],
  )
  .on(jingleSelectionReset, () => [])

// Selection Modal
export const {
  modalOpened: jingleSelectionModalOpened,
  modalClosed: jingleSelectionModalClosed,
  $isModalOpened: $isJingleSelectionModalOpen,
} = createModalModel()
